// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d5-2";
export var aiChatCartContainerExit = "_d5-4";
export var aiChatContainerLarge = "_d5-0";
export var aiChatContainerSmall = "_d5-1";
export var aiChatIcon = "_d5-6";
export var slideInFromRight = "_d5-3";
export var slideOutToRight = "_d5-5";